import { IconInfoCircle } from '@tabler/icons-react'
import { ReactNode } from 'react'

import { AstraHeading, AstraIcon, AstraTooltip } from '~/astra'

type Props = {
    title: string
    afterTitle?: ReactNode
    description?: string
    children: ReactNode
}

export const Section = ({ title, description, children, afterTitle }: Props) => (
    <section className="flex max-h-full w-full shrink flex-col gap-4 overflow-auto bg-surface-base">
        <div className="flex w-full items-center gap-1.5">
            <div className="flex items-center gap-1.5">
                <AstraHeading as="h3">{title}</AstraHeading>
                {description && (
                    <AstraTooltip tooltipContent={description}>
                        <AstraIcon icon={IconInfoCircle} />
                    </AstraTooltip>
                )}
            </div>
            {afterTitle}
        </div>
        {children}
    </section>
)
